import { render, staticRenderFns } from "./icon-sprite.vue?vue&type=template&id=c8adeafa&scoped=true&"
import script from "./icon-sprite.vue?vue&type=script&lang=js&"
export * from "./icon-sprite.vue?vue&type=script&lang=js&"
import style0 from "./icon-sprite.vue?vue&type=style&index=0&id=c8adeafa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8adeafa",
  null
  
)

/* custom blocks */
import block0 from "./icon-sprite.vue?vue&type=custom&index=0&blockType=doc"
if (typeof block0 === 'function') block0(component)

export default component.exports